import hero from "../images/volunteer_hero.png";
import sc_logo_desk from "../images/logo_home_mobile.png";
import Navbar from "../sections/Navbar.js";

import logo_henrysmith from "../images/logos/henrysmith.png";
import logo_lloyds from "../images/logos/lloyds.png";
import logo_healthcarepartnership from "../images/logos/healthcarepartnership.png";
import logo_communityfoundation from "../images/logos/communityfoundation.png";
import logo_communityfund from "../images/logos/communityfund.png";
import logo_comicrelief from "../images/logos/comicrelief.png";
import logo_solace from "../images/logos/solace.png";
import logo_shpresa from "../images/logos/shpresa.png";
import logo_henry from "../images/logos/henry.png";
import logo_pramdepot from "../images/logos/pramdepot.png";



import partner_hero from "../images/involved_partner.png";
import dontate_hero from "../images/involved_donate.png";
import fundraise_hero from "../images/fundraise_union.png";

import Footer from "../sections/Footer.js";
import { useRef, useState, useCallback } from "react";
import useScrollToSection from "../hooks/useScrollToSection";
import SectionReveal from "../components/SectionReveal";

// ── Toggle: set to true for scroll-triggered fade-up on content sections ──
const showSectionReveal = true;

const Involved = () => {
  const volunteerPageRef = useRef();
  const partnerPageRef = useRef();
  const fundraiseComponent = useRef();
  const donationComponent = useRef();
  const giftComponent = useRef();

  // Track navbar overlay state for logo z-index toggle
  const [isNavOverlayActive, setIsNavOverlayActive] = useState(false);
  const handleOverlayActive = useCallback((active) => {
    setIsNavOverlayActive(active);
  }, []);

  // Use custom hook to handle URL-based scrolling to sections
  useScrollToSection({
    "volunteer": volunteerPageRef,
    "partner": partnerPageRef,
    "donate": donationComponent,
    "fundraise": fundraiseComponent,
    "Leave-a-gift-in-your-Will": giftComponent
  });
  return (
    <div className="">
      <Navbar whichRef={volunteerPageRef} currentPage="get-involved" onOverlayActive={handleOverlayActive} />

      {/* ---------------------------------------------------------------------------------------------------------------
    ---------------------------------------OPENING Get Support content--------------------------------------------------------
    ----------------------------------------------------------------------------------------------------------------- */}
      <div className="bg-[#DCB1FA]">
        <div className="mx-auto max-w-[1240px]">
          <a href="/" className="0">
            <img
              src={sc_logo_desk}
              className={`xs:mt-6  md:ml-6 s:ml-12 xs:ml-8  responsive-home-logo-width md:w-[100px] sm:w-[110px] ss:w-[110px] s:w-[100px] xs:w-[90px] absolute top-0 ${isNavOverlayActive ? '' : 'z-[22]'}`}
              alt="secret-circle-logo"
            />
          </a>
          <div className="flex  md:flex-row items-center w-full bg-[#DCB1FA] overflow-hidden">
            <div className="max-w-[1240px]  absolute md:mb-0 md:mt-0 w-[100%] ">
              <h1 className="xs:z-10 xs:relative md:static md:ml-0 xs:text-left md:text-center xs:mb-0  xs:mr-0  xs:ml-[2rem] s:ml-[3rem] sm:ml-[4rem]  md:mt-0  font-sans antialiased mds:text-[4.8rem] mds:leading-[2.2rem] s:text-[3rem] xss:text-[2.8rem] xss:leading-[2.2rem] align-middle text-[#b24029]">
                Get involved
              </h1>
            </div>
            {/* --------------------------------------------------------------------------------------------------------- */}
            <div className=" md:mt-0  md:mb-0 w-[100%]  ">
              <img
                src={hero}
                className=" xs:relative md:static ss:left-[20%] xs:left-[15%] md:left-0  xs:mx-auto md:min-h-[388px] md:max-h-[100vh] ss:h-[100%] xs:h-[188px] ss:mt-0 xs:mt-[18%] hero-img float-right"
                alt="hero"
              />
            </div>
          </div>
        </div>
      </div>



   
      {/* ---------------------------------------------------------------------------------------------------------------
    --------------------------------------- Partner with us --------------------------------------------------------
    ----------------------------------------------------------------------------------------------------------------- */}
      <div ref={partnerPageRef} className="bg-[#ffe1d9]">
        <div className="mx-auto max-w-[1240px] responsive-maternity-pt  ">
          <SectionReveal enabled={showSectionReveal}>
          <div className="flex xs:flex-col md:flex-row xs:items-center md:items-start w-full md:min-h-[550px] overflow-hidden">
            <div className=" module-left xs:mb-[0vh] xs:mt-[0vh] md:mt-0 md:mb-0 xs:w-4/5 md:w-[60%]">
              <h1 className="module-headlineL w-[100%]">
                Partner with&nbsp;us
              </h1>
            
              <p className="module-bodycopyL w-[100%]">
               Sister Circle is more than a charity; it’s a movement for justice and compassion. Every woman we support represents a victory against systemic inequality. Every statistic we fight to change is a step closer to a world where underrepresented women no longer fear being unheard or unseen in the moments they need care the most.
               < br />< br />
              Partnering with other like-minded community organisations and funding partners is critical for us to continue supporting the women in our community.
              < br />< br />
              If a partnership between Sister Circle and your organisation would be beneficial and could positively impact outcomes in women's health, please contact Karen Wint, CEO.
              < br />< br />
              Or, if your organisation is able to help fund our work or accepts applications for grant funding, please contact Karen.
              </p>
               <div className="bg-[#DCB1FA] xs:mb-[0vh] xs:px-4 md:px-0 pt-10 pb-[2rem] xs:mt-[5vh] md:mt-12  md:mb-0   ctabox-width  max-w-[450px]">
                <p className="xs:mt-0 xs:mr-0 xs:ml-0 md:mt-0 md:mr-10 md:ml-7  font-sans antialiased module-bodycopy-involved tracking-[-0.01em] align-middle text-[#b24029]">
                 
                  Karen Wint<br />
                  Chief Executive<br />
                  <span>
                    <a
                      className="underline"
                      href="mailto:Karen.wint@sistercircle.org.uk"
                      rel="noreferrer"
                      target="_blank"
                    >
                      Karen.wint@sistercircle.org.uk
                    </a>
                  </span>
                  <br></br>
                  <span> or call </span>
                  <span>
                     
                     <a className="underline" href="tel:07985 905562">
                     07985 905562
                    </a>
                  </span>

                </p>
                
              </div>
            </div>
            {/* --------------------------------------------------------------------------------------------------------- */}
            <div className=" md:mr-0 md:mb-[0vh] md:mt-[0vh] xs:mb-[5vh] xs:mt-[5vh] xs:w-[95%] md:w-[40%] xs:ml-[5%] md:ml-0">
              <img
                src={partner_hero}
                className=" max-h-[671px] h-[auto] mx-auto"
                alt="hero"
              />
            </div>
          </div>

          {/* ---------------------------------------------------------------------------------------------------------------
          --------------------------------------- Quote Section  --------------------------------------------------------
          ----------------------------------------------------------------------------------------------------------------- */}
          <div className="mx-auto max-w-[1240px] xs:w-4/5 md:w-full md:px-[1.5rem] min-[1270px]:pl-[4.5rem] xs:pt-[4rem] md:pt-[7rem] xs:pb-[3rem] md:pb-[3rem]">
            <p className="module-quote">
              <span className="module-quote-highlight">
                &ldquo;Finding accessible opportunities for counselling with interpretation has been a real challenge in recent weeks, so we are incredibly grateful to have been able to work with Sister Circle. You are always so supportive, consistently going the extra mile to empower women through an inclusive approach that centres their individual needs &ndash; even when clients are not directly supported by your organisation. Thank you once again.&rdquo;
              </span>
            </p>
            <div className="xs:mt-6 md:mt-8">
              <span className="text-[#b24029] text-[1.5rem] leading-none">—</span>
              <p className="module-bodycopy w-[95%] ml-0 mt-0" style={{ fontSize: 'clamp(22px, calc(16.86px + 0.669vw), 26px)', lineHeight: 'clamp(26.4px, calc(20.23px + 0.803vw), 31.2px)' }}>
                Referring Partner from Refuge
              </p>
            </div>
          </div>

          <div className="flex xs:flex-col md:flex-row items-center w-full md:max-h-[700px] overflow-hidden">
            <div className="md:mr-12 md:ml-0 md:mb-[7.4rem] md:mt-[4rem] sm:mb-[3rem] xs:mb-[2rem] xs:mt-[2vh] sm:mt-[2vh] xs:w-4/5 md:w-6/12 ">
              <h1 className="module-subhead module-left-involved mb-[40px]">
             
                Funding partners
              </h1>
           

              <div className="md:pl-[68px]   flex justify-start ">
                <div className="xs:pr-7 ss:pr-10 md:pr-7 mds:pr-10 border-0">
                  <img
                    src={logo_henrysmith}
                    className="xs:mb-[17px] md:mb-[37px] border-0 max-h-[63px] w-auto"
                    alt="hero"
                  />
                </div>
                <div className="xs:pr-6 ss:pr-9 md:pr-6 mds:pr-9  border-0  ">
                  <img
                    src={logo_lloyds}
                    className="xs:mb-[17px] md:mb-[37px]  border-0 max-h-[63px] w-auto"
                    alt="hero"
                  />
                </div>
                <div className="pr-0 border-0  ">
                  <img
                    src={logo_healthcarepartnership}
                    className="xs:mb-[17px] md:mb-[37px]  border-0 max-h-[63px] w-auto"
                    alt="hero"
                  />
                </div>
              </div>

              <div className="md:pl-[68px]   flex justify-start ">
                <div className="xs:pr-7 ss:pr-10 md:pr-7 mds:pr-10 border-0 ">
                  <img
                    src={logo_communityfoundation}
                    className="xs:mb-[17px] md:mb-[37px]  border-0 max-h-[81px] w-auto"
                    alt="hero"
                  />
                </div>
                <div className="xs:pr-6 ss:pr-9 md:pr-6 mds:pr-9 border-0  ">
                  <img
                    src={logo_communityfund}
                    className="xs:mb-[17px] md:mb-[37px]  border-0 max-h-[81px] w-auto"
                    alt="hero"
                  />
                </div>
                <div className="pr-0 border-0  ">
                  <img
                    src={logo_comicrelief}
                    className="xs:mb-[17px] md:mb-[37px]  border-0 max-h-[81px] w-auto"
                    alt="hero"
                  />
                </div>
              </div>
            </div>
            {/* --------------------------------------------------------------------------------------------------------- */}
            <div className="md:mr-0 md:ml-0 md:mb-[7.4rem] md:mt-[4rem] sm:mb-[4.5rem]  xs:mb-[3.5rem] xs:mt-[5vh] xs:w-4/5 md:w-6/12 ">
              <h1 className="module-subhead module-left-involved mb-[40px]">
            
                Support/Funder partners
              </h1>
            

              <div className="md:px-[68px] flex justify-start xs:w-[60%] md:w-[90%] md:max-w-[500px]">
                <div className="xs:pr-7 ss:pr-10 md:pr-7 mds:pr-10 border-0">
                  <img
                    src={logo_solace}
                    className="mb-[37px] border-0 max-h-[63px] w-auto"
                    alt="hero"
                  />
                  {/* w-133 */}
                </div>
                <div className="pr-0 border-0  ">
                  <img
                    src={logo_shpresa}
                    className="mb-[37px] border-0 max-h-[63px] w-auto"
                    alt="hero"
                  />
                  {/* w-181 */}
                </div>
              </div>
              <div className="md:px-[68px] flex justify-start xs:w-[60%] md:w-[90%]  md:max-w-[500px]">
                <div className="xs:pr-7 ss:pr-10 md:pr-7 mds:pr-10 border-0">
                  <img
                    src={logo_henry}
                    className="mb-[37px] border-0 max-h-[81px] w-auto"
                    alt="hero"
                  />
                </div>
                <div className="pr-0 border-0">
                  <img
                    src={logo_pramdepot}
                    className="mb-[37px] border-0 max-h-[81px] w-auto"
                    alt="hero"
                  />
                </div>
              </div>
            </div>
          </div>
          </SectionReveal>
        </div>
      </div>

      {/* ---------------------------------------------------------------------------------------------------------------
    --------------------------------------- Make a donation --------------------------------------------------------
    ----------------------------------------------------------------------------------------------------------------- */}
      <div ref={donationComponent} className="bg-[#ff794e]">
        <div className="mx-auto max-w-[1240px]">
          <SectionReveal enabled={showSectionReveal}>
          <div className="flex xs:flex-col-reverse md:flex-row items-center w-full md:max-h-[650px] overflow-hidden">
            <div className="md:mr-6 md:ml-7 md:mb-[18vh] md:mt-[18vh] xs:mb-[5rem] xs:mt-[5vh] xs:w-4/5 md:w-6/12 ">
              <img
                src={dontate_hero}
                className=" xs:mx-auto max-h-[312px] h-[100%]"
                alt="hero"
              />
            </div>
            {/* --------------------------------------------------------------------------------------------------------- */}
            <div className=" xs:mb-[0vh] xs:mt-[4rem] md:mt-[4rem]  md:mb-[5rem]  xs:w-4/5 md:w-6/12">
              <h1 className="module-headline text-[#ffe1d9]">
                {/* <h1
                className="md:mb-8 first-letter:xs:mt-6 xs:mr-0 xs:ml-0  md:mt-0 md:mr-6  md:ml-8 mds:ml-16 lgx:w-[352px] font-sans antialiased 
                text-[4.9rem] xl:text-[4.9rem] lgxx:text-[4.9rem] lgx:text-[4.7rem] lg:text-[4.3rem] mdx:text-[3.9rem] mds:text-[3.5rem] md:text-[3rem]  sm:text-[3rem] s:text-[3rem] xss:text-[2.9rem] leading-[4.5rem] xl:leading-[4.5rem] lgxx:leading-[4.5rem] lgx:leading-[4.3rem] lg:leading-[3.9rem] mdx:leading-[3.5rem] mds:leading-[3.1rem] md:leading-[2.6rem] sm:leading-[2.6rem] s:leading-[2.6rem] xss:leading-[2.6rem]
                align-middle text-[#ffe1d9]"
              > */}
                Donate
              </h1>
              <p className="module-bodycopy text-[#ffe1d9]">
              {/* <p className="xs:mt-6 xs:mr-0 xs:ml-0 md:mt-0 md:mr-6 md:ml-8 mds:ml-16  mds:w-[360px] min-[1165px]:w-[500px] font-sans antialiased mds:text-[1.3rem] mds:leading-[1.54rem] xss:text-[1.3rem] xss:leading-[1.654rem] tracking-[-0.01em] align-middle text-[#ffe1d9]"> */}
                Sister Circle is a charity operating in London for over 40 years. We rely on volunteer support, pro-bono services and donations from individuals and funding from organisations to continue our programmes.
                <br />
                <br />
                Even the smallest donation can make a significant difference to the women and babies we support, if you are able to contribute to our work, you can donate safely and securely using Donorbox.
              </p>
              <button className="mt-8 xs:mr-0 xs:ml-0  md:mr-6 md:ml-7 mds:ml-7 block px-7 py-[0.4rem] xsss:text-lg xs:text-[0.9rem] xs:leading-7 font-medium text-center text-[#ffe1d9] border-2 border-[#ffe1d9] rounded-full">
                <a
                  href="https://donorbox.org/sister-circle"
                  rel="noreferrer"
                  target="_blank"
                >
                  Donate
                </a>
              </button>
            </div>
          </div>
          </SectionReveal>
        </div>
      </div>

      {/* ---------------------------------------------------------------------------------------------------------------
    --------------------------------------- fundraise--------------------------------------------------------------------------------------------------------------------------------- */}
      <div ref={fundraiseComponent} className="bg-[#ffe1d9]">
       

        <div className="mx-auto max-w-[1240px] responsive-maternity-pt  ">
          <SectionReveal enabled={showSectionReveal}>
          <div className="flex xs:flex-col md:flex-row xs:items-center md:items-start w-full md:min-h-[550px] overflow-hidden">
            <div className=" module-left xs:mb-[0vh] xs:mt-[0vh] md:mt-0 md:mb-[6rem] xs:w-4/5 md:w-[60%]">
              <h1 className="module-headlineL w-[100%]">
                Fundraise
              </h1>
            
              <p className="module-bodycopyL w-[100%]">
               Fundraising in your community, for your community, is a powerful way to bring people together and support women locally. Whether it's a bake sale, coffee morning or craft event, every effort makes a difference. Tell us what you're planning and we'll help spread the word — and may even join you.
               
              
              </p>
               <div className="bg-[#DCB1FA] xs:mb-[0vh] xs:px-4 md:px-0 pt-10 pb-[2rem] xs:mt-[5vh] md:mt-12  md:mb-0   ctabox-width  max-w-[450px]">
                <p className="xs:mt-0 xs:mr-0 xs:ml-0 md:mt-0 md:mr-10 md:ml-7  font-sans antialiased module-bodycopy-involved tracking-[-0.01em] align-middle text-[#b24029]">
                 If you'd rather get active, you can take on a sponsored challenge, fundraise via our JustGiving page, or ask for donations instead of gifts for a birthday or special occasion. Together, we can make change happen.

                 
                 

                </p>
                 <button className="mt-6 mb-6 xs:mr-0 xs:ml-0  md:mr-0 md:ml-7 block px-5 py-[0.4rem] s:text-base xs:text-[0.9rem] font-medium text-center text-[#b24029] border-2 border-[#b24029] rounded-full">
                  <a
                    href="https://www.justgiving.com/charity/Sister-Circle"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Start Fundraising
                  </a>
                </button>
                
              </div>
            </div>
            {/* --------------------------------------------------------------------------------------------------------- */}
            <div className=" md:mr-0 md:mb-[0vh] md:mt-[0vh] xs:mb-[6rem] xs:mt-[5vh] xs:w-[95%] md:w-[40%] xs:ml-[5%] md:ml-0">
              <img
                src={fundraise_hero}
                className=" max-h-[671px] h-[auto] mx-auto"
                alt="hero"
              />
            </div>
          </div>
          </SectionReveal>

        
        </div>
      </div>

      {/* --------------------------------------------------content 5 end--------------------------------------------------- */}
      <Footer />
    </div>
  );
};

export default Involved;
